import { Dropdown } from "react-bootstrap";
import { Navbar } from "../common/Navbar";
import { Sidebar } from "../common/Sidebar";
import { useCallback, useEffect, useState } from "react";
import { ReactComponent as DownArrow } from "../../assets/svg/down_arror.svg";
import { ReactComponent as DownloadIc } from "../../assets/svg/download_Ics.svg";
import DateRangePicker from "../common/dateRange";
import { format } from "date-fns";
import "./vendor-history.css";
import { ReactComponent as SearchIc } from "../../assets/svg/search.svg";
import { getVendorHistoryListApi, exportVendorHistoryApi } from "./vendor-history-api";
import MultiSelectDropdown from "../common/commonMultiDropDown";
import ReactPaginate from "react-paginate";
import { ReactComponent as DownArrowIc } from "../../assets/svg/down_arrow_ics.svg";
import { ReactComponent as RarIc } from "../../assets/svg/rar_ic.svg";
import { ReactComponent as LarIc } from "../../assets/svg/lar_ic.svg";
import PurchaseRequestTab from "./PurchaseRequestTab";
import PurchaseQuotationTab from "./PurchaseQuotationTab";
import PurchaseOrderTab from "./PurchaseOrderTab";
import TransactionsTab from "./TransactionsTab";
import ProfileImageModal from "../common/common-preview";
function VendorHistoryListPage() {
  // Api Url
  const apiUrl = process.env.REACT_APP_API_URL;

  // Varibale
  const [selectedSortby, setSelectedSortBy] = useState({
    value: "created desc",
    label: "Created (Newest)",
  });
  const sortByOptions = [
    { value: "created asc", label: "Created (Oldest)" },
    { value: "created desc", label: "Created (Newest)" },
    { value: "updated asc", label: "Updated Date (Oldest)" },
    { value: "updated desc", label: "Updated Date (Newest)" },
  ];

  const [startDateSave, setStartDateSave] = useState(null);
  const [endDateSave, setEndDateSave] = useState(null);
  const [isSortOpen, setIsSortOpen] = useState(false);
  const [isDateOpen, setIsDateOpen] = useState(false);
  const [isSortTouched, setIsSortTouched] = useState(false);
  const [isSortFocused, setIsSortFocused] = useState(false);
  const [isDateFocused, setIsDateFocused] = useState(false);
  const [activeMenu, setActiveMenu] = useState("RFQ");
  const [search, setSearch] = useState("");
  const [hoveredIndex, setHoveredIndex] = useState(null);
  const [vendorHistoryList, setVenHistoryList] = useState([]);
  const [selectedVendors, setSelectedVendors] = useState([]);
  const [pageCount, setPageCount] = useState(0);
  const [totalCount, setTotalCount] = useState(0);
  const [itemOffset, setItemOffset] = useState(0);
  const [itemsPerPage, setItemsPerPage] = useState(10);

  const [isLoading, setIsLoading] = useState(false);

  // Functions
  const handleDateChange = ({ start, end }) => {
    console.log("Selected Start:", start);
    console.log("Selected End:", end);

    const formattedStart = start ? format(start, "yyyy-MM-dd") : null;
    const formattedEnd = end ? format(end, "yyyy-MM-dd") : null;

    console.log("Formatted Start:", formattedStart);
    console.log("Formatted End:", formattedEnd);

    setStartDateSave(formattedStart);
    setEndDateSave(formattedEnd);
  };

  const [currentPage, setCurrentPage] = useState(0);

  const handlePageClick = (event) => {
    const newOffset = event.selected;
    setItemOffset(newOffset);
    setCurrentPage(event.selected); // ✅ update the active page index
  };
  const handleFilterChange = () => {
    setCurrentPage(0); // visually reset
    setItemOffset(0); // reset API offset
  };

  const handleExport = async () => {
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      search: search,
      type:
        activeMenu === "RFQ"
          ? "purchase_requests"
          : activeMenu === "Purchase Quotation"
            ? "purchase_quotation"
            : activeMenu === "Purchase Order"
              ? "purchase_orders"
              : "transactions",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };

    if (selectedVendors && selectedVendors.length > 0) {
      param.vendor_id = `[${selectedVendors.map((v) => v.value).join(",")}]`;
    }

    try {
      const response = await exportVendorHistoryApi(param);
      if (response?.data?.success) {
        if (response.data.url) {
          window.location.href = response.data.url;
        } else if (response.data.base64) {
          const link = document.createElement("a");
          link.href = `data:application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;base64,${response.data.base64}`;
          link.download = response.data.file_name || "Vendor_History.xlsx";
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        }
      } else {
        console.error("Export failed:", response?.data?.message);
        alert(response?.data?.message || "Export failed");
      }
    } catch (err) {
      console.error("Error exporting vendor history:", err);
      alert("Error exporting vendor history");
    } finally {
      setIsLoading(false);
    }
  };

  // Api
  const getVendorHistoryList = useCallback(async () => {
    setVenHistoryList([]);
    setIsLoading(true);
    const [field, dir] = selectedSortby?.value?.split(" ") || [
      "Created",
      "desc",
    ];
    const param = {
      limit: itemsPerPage,
      skip: itemOffset * itemsPerPage,
      search: search,
      type:
        activeMenu === "RFQ"
          ? "purchase_requests"
          : activeMenu === "Purchase Quotation"
            ? "purchase_quotation"
            : activeMenu === "Purchase Order"
              ? "purchase_orders"
              : "transactions",
      from_date: startDateSave,
      to_date: endDateSave,
      sort_field: field,
      sort_dir: dir,
    };
    if (selectedVendors && selectedVendors.length > 0) {
      param.vendor_id = `[${selectedVendors.map((v) => v.value).join(",")}]`;
    }

    try {
      const response = await getVendorHistoryListApi(param);
      if (response.data.success === true) {
        setTotalCount(response.data.total_rec ?? 0);
        setPageCount(response.data.total_pgs ?? 0);
        setVenHistoryList(response.data.histories ?? []);
      }
    } catch (err) {
      console.error("Error fetching category:", err);
    } finally {
      setIsLoading(false);
    }
  }, [
    activeMenu,
    selectedSortby,
    search,
    startDateSave,
    endDateSave,
    itemOffset,
    itemsPerPage,
    selectedVendors,
  ]);

  // useEffect

  useEffect(() => {
    getVendorHistoryList();
  }, [getVendorHistoryList]);

  const [showProfilePopup, setShowProfilePopup] = useState(false);
  const [selectedProfile, setSelectedProfile] = useState("");

  return (
    <>
      <div className="d-flex">

        <Sidebar currentfile="Vendor History" />
        <div className="rounded-4 flex-grow-1 bg-half-white">
          <Navbar pageTitle="Vendor History" />

          <div className="rounded-4 m-3 p-3 bg-white">
            <div className="fs-24 fw-700 textcolor">Vendor History</div>
            <div className="d-flex  mt-2 gap-3">
              <div onClick={(e) => e.stopPropagation()}>
                <Dropdown show={isSortOpen} onToggle={setIsSortOpen}>
                  <Dropdown.Toggle
                    variant="light"
                    id="dropdown-sort"
                    className={`d-flex align-items-center justify-content-between filter-dropdown-btn ${
                      isSortOpen || isSortFocused || isSortTouched ? "active" : ""
                    }`}
                    style={{
                      borderRadius: "12px",
                      border:
                        isSortOpen || isSortFocused || isSortTouched
                          ? "1px solid #4F46E5"
                          : "1px solid #EBEBEB",
                      boxShadow:
                        isSortOpen || isSortFocused || isSortTouched
                          ? "0 0 0 3px rgba(79, 70, 229, 0.18)"
                          : "none",
                      padding: "6px 12px",
                      backgroundColor:
                        isSortOpen || isSortFocused || isSortTouched
                          ? "#F5F3FF"
                          : "white",
                      outline: "none",
                    }}
                    title={selectedSortby.label}
                    onFocus={() => setIsSortFocused(true)}
                    onBlur={() => setIsSortFocused(false)}
                  >
                    {/* Left: "Sort by" label */}
                    <span className="fs-12 fw-400 textGrey">Sort by :</span>

                    {/* Right: Selected + arrow */}
                    <span className="d-flex align-items-center px-1">
                      <span className="dropdown-text">
                        {selectedSortby.label}
                      </span>

                      <span className="dropdown-toggle-arrow textPurple">
                        <DownArrow />
                      </span>
                    </span>
                  </Dropdown.Toggle>

                  <Dropdown.Menu
                    style={{
                      backgroundColor: "white",
                      borderRadius: "8px",
                      border: "1px solid #EBEBEB",
                      boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
                    }}
                  >
                    {sortByOptions.map((option) => (
                      <Dropdown.Item
                        className="fs-14 fw-500 textcolor"
                        key={option.value}
                        onClick={(e) => {
                          e.stopPropagation(); // Prevent parent onClick from firing
                          setSelectedSortBy(option); // Execute your selection logic
                          setIsSortTouched(true);
                          setIsSortOpen(false);
                        }}
                        active={selectedSortby.value === option.value}
                      >
                        {option.label}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>
              <div>
                <MultiSelectDropdown
                  apiUrl={`${apiUrl}get_vendor`}
                  placeholder="Vendor"
                  value={selectedVendors}
                  onSelect={setSelectedVendors}
                  handleClear={() => setSelectedVendors([])}
                />
              </div>
              <div
                className={`d-flex align-items-center px-1 vendor-history-filter-item ${
                  isDateOpen || isDateFocused || startDateSave || endDateSave
                    ? "active"
                    : ""
                }`}
                style={{
                  borderRadius: "12px",
                  border:
                    isDateOpen || isDateFocused || startDateSave || endDateSave
                      ? "1px solid #4F46E5"
                      : "1px solid #EBEBEB",
                  boxShadow:
                    isDateOpen || isDateFocused || startDateSave || endDateSave
                      ? "0 0 0 3px rgba(79, 70, 229, 0.18)"
                      : "none",
                  backgroundColor:
                    isDateOpen || isDateFocused || startDateSave || endDateSave
                      ? "#F5F3FF"
                      : "white",
                  outline: "none",
                  cursor: "pointer",
                }}
                tabIndex={0}
                onFocus={() => setIsDateFocused(true)}
                onBlur={() => setIsDateFocused(false)}
              >
                <span className="fs-12 fw-400 textGrey">Date :</span>
                <span
                  className="dropdown-text1 textPurple"
                  style={{
                    height: "28px",
                    display: "flex",
                    alignItems: "center",
                  }}
                >
                  {" "}
                  <DateRangePicker
                    onChange={handleDateChange}
                    onCalendarOpen={() => setIsDateOpen(true)}
                    onCalendarClose={() => setIsDateOpen(false)}
                    onFocus={() => setIsDateFocused(true)}
                    onBlur={() => setIsDateFocused(false)}
                  />
                </span>
              </div>
            </div>
            <div className="d-flex align-content-between justify-content-between mt-4">
              <div className="d-flex gap-2 flex-wrap">
                <div
                  className={`fs-12 fw-500 menu-button ${
                    activeMenu === "RFQ" ? "active text-white" : "textcolor"
                  }`}
                  onClick={() => {
                    setActiveMenu("RFQ");
                    handleFilterChange();
                  }}
                >
                  RFQ
                </div>
                <div
                  className={`fs-12 fw-500 menu-button ${
                    activeMenu === "Purchase Quotation" ? "active text-white" : "textcolor"
                  }`}
                  onClick={() => {
                    setActiveMenu("Purchase Quotation");
                    setItemOffset(0);
                  }}
                >
                  Purchase Quotation
                </div>
                <div
                  className={`fs-12 fw-500 menu-button ${
                    activeMenu === "Purchase Order" ? "active text-white" : "textcolor"
                  }`}
                  onClick={() => {
                    setActiveMenu("Purchase Order");
                    setItemOffset(0);
                  }}
                >
                  Purchase Order
                </div>
                <div
                  className={`fs-12 fw-500 menu-button ${
                    activeMenu === "Transactions" ? "active text-white" : "textcolor"
                  }`}
                  onClick={() => {
                    setActiveMenu("Transactions");
                    setItemOffset(0);
                  }}
                >
                  Transactions
                </div>
              </div>
              <div className="d-flex flex-wrap gap-3">
                <div className="search-wrap d-flex align-items-center gap-2 px-3 py-2">
                  <SearchIc />
                  <input
                    type="text"
                    placeholder="Search"
                    className="border-0 outline-0 rounded-3 fs-14 fw-500 textcolor"
                    value={search || ""}
                    onChange={(e) => setSearch(e.target.value)}
                  />
                </div>

                <button
                  className="d-flex align-items-center justify-content-center gap-2 bg-transparent"
                  style={{
                    border: "1px solid #4F46E5",
                    borderRadius: "20px",
                    padding: "6px 20px",
                    color: "#4F46E5",
                    height: "38px"
                  }}
                  onClick={handleExport}
                  disabled={isLoading}
                >
                  <DownloadIc style={{ width: "16px", height: "16px" }} />
                  <span className="fs-13 fw-600">Export</span>
                </button>
              </div>
            </div>
            <div className="bg-white rounded-4 mt-3 w-100 p-3">
              {activeMenu === "Transactions" ? (
                <TransactionsTab
                  vendorHistoryList={vendorHistoryList}
                  hoveredIndex={hoveredIndex}
                  setHoveredIndex={setHoveredIndex}
                />
              ) : activeMenu === "Purchase Quotation" ? (
                <PurchaseQuotationTab
                  vendorHistoryList={vendorHistoryList}
                  hoveredIndex={hoveredIndex}
                  setHoveredIndex={setHoveredIndex}
                />
              ) : activeMenu === "Purchase Order" ? (
                <PurchaseOrderTab
                  vendorHistoryList={vendorHistoryList}
                  hoveredIndex={hoveredIndex}
                  setHoveredIndex={setHoveredIndex}
                />
              ) : (
                <PurchaseRequestTab
                  vendorHistoryList={vendorHistoryList}
                  hoveredIndex={hoveredIndex}
                  setHoveredIndex={setHoveredIndex}
                />
              )}
            </div>
          </div>

          <div className=" d-flex justify-content-between align-items-center flex-wrap gap-3 px-3">
            <Dropdown>
              <span className="pagination-color">Records per page: &nbsp;</span>
              <Dropdown.Toggle
                id="dropdown-basic"
                className="bg-transparent pagination-color  border-0 custom-dropdown-toggle p-0"
              >
                <span className="bg-white textcolor no-of-rows rounded-3 px-2 py-2">
                  {itemsPerPage} <DownArrowIc />
                </span>
              </Dropdown.Toggle>
              <Dropdown.Menu
                className="my-2"
                style={{ minWidth: "unset", width: "30%" }}
              >
                {[10, 25, 50, 75, 100].map((size) => (
                  <Dropdown.Item
                    key={size}
                    onClick={() => {
                      setItemsPerPage(size);
                    }}
                    active={itemsPerPage === size}
                    className="text-center"
                  >
                    {size}
                  </Dropdown.Item>
                ))}
              </Dropdown.Menu>
            </Dropdown>

            <div className="d-flex align-items-center gap-2">
              <ReactPaginate
                previousLabel={
                  <div
                    className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px" }}
                  >
                    <LarIc />
                  </div>
                }
                nextLabel={
                  <div
                    className="rounded-5 bg-white d-flex align-items-center justify-content-center"
                    style={{ width: "32px", height: "32px" }}
                  >
                    <RarIc />
                  </div>
                }
                breakLabel="..."
                pageCount={pageCount}
                onPageChange={handlePageClick}
                forcePage={currentPage} // ✅ this keeps UI in sync
                containerClassName="pagination"
                activeClassName="active" // ✅ will now properly update
              />
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default VendorHistoryListPage;
